import React, {useEffect} from "react";

import styles from "./AssistantsTab.module.css"
import {Button, ButtonState} from "../../../../elements/button/Button";
import {BotTable} from "../BotTable";
import {useAppDispatch} from "../../../../../app/hooks";
import {FormName, openForm} from "../../../../elements/formProvider/formSlice";
import {MenuItem, updateSelectedMenuItem} from "../../../platform/platformSlice";

export const AssistantsTab: React.FC = () => {

    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(updateSelectedMenuItem(MenuItem.ASSISTANTS))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCreateAssistantClick = () => {
        dispatch(openForm({name: FormName.CREATE_BOT}))
    }

    return <div className={styles.wrapper}>
        <div className={styles.headerSectionWrapper}>
            <span className={styles.title}>Assistants</span>
            <Button
                title={"Create assistant"}
                iconSrc={"/plusIcon.svg"}
                state={ButtonState.PRIMARY}
                handleClick={handleCreateAssistantClick}
            />
        </div>
        <BotTable/>
    </div>
}
